export const MODULE_NAME = 'TOAST'

// Mutations
export const SET_TOASTS = 'SET_TOAST'
// Actions
export const INITIALIZE = 'INITIALIZE'
export const ADD_TOAST = 'ADD_TOAST'
export const DELETE_TOAST = 'DELETE_TOAST'
// Getters
export const GET_TOASTS = 'GET_TOASTS'

export interface ToastState {
  toasts: Toast[]
}

export interface ToastAction {
  (): void
}

export interface Toast {
  id: string
  type: ToastType
  message: string
  closeManually?: boolean
  action?: ToastAction
}

export enum ToastType {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Custom = ''
}

export interface AddToastPayload {
  type: ToastType
  message: string
  closeManually?: boolean
  action?: ToastAction
}

export interface DeleteToastPayload {
  id: number
}

export interface SetToastsPayload {
  toasts: Toast[]
}
